import React from "react";
import {
    PropertyEditorTextSizeSelection,
    PropertyEditorTextStyleSelection,
    TextStyleSelectionInterface,
} from "../PropertyEditorTextStyleSelection";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class TextStyleButtons implements TextStyleSelectionInterface {
    editObject: object = {};
    label: string = "TextEditor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
}

class TextStyleButtons2 implements TextStyleSelectionInterface {
    editObject: IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "textValue"), new ValidationIssue("issue2", "textValue")];
        },
    };
    label: string = "TextEditor";
    parentDefaultValue: string | null = null;
    propertyName: string = "textValue";
}

export const PropertyEditorTextSelection = [
    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons();
            return (
                <PropertyEditorTextSizeSelection
                    {...args}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Size",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons();
            return (
                <PropertyEditorTextStyleSelection
                    {...args}
                    onChange={() => {
                        console.log(args.editObject);
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Style",
    ),

    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons();
            return (
                <PropertyEditorTextSizeSelection
                    {...args}
                    error={"error text"}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Size - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons();
            return (
                <PropertyEditorTextStyleSelection
                    {...args}
                    error={"error text"}
                    onChange={() => {
                        console.log(args.editObject);
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Style - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons2();
            return (
                <PropertyEditorTextSizeSelection
                    {...args}
                    onChange={() => logCallback(Reflect.get(args.editObject, args.propertyName))}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Size - Validation Provider",
    ),
    new StoryNode(
        (logCallback) => {
            let args = new TextStyleButtons2();
            return (
                <PropertyEditorTextStyleSelection
                    {...args}
                    onChange={() => {
                        console.log(args.editObject);
                        logCallback(Reflect.get(args.editObject, args.propertyName));
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Text Selection",
        "Style - Validation Provider",
    ),
];
